module.exports = __webpack_public_path__ + "img/sg.6ae2dc5b.svg";